<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable width="auto" persistent :fullscreen="$vuetify.breakpoint.mobile">
      <v-form ref="formDivider" v-model="valid" lazy-validation @submit.prevent="concretarReciboEditable">
        <v-card tile v-if="recibo">
          <v-toolbar dark color="primary" dense flat class="max-height">
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text"> Recibo </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="py-2">
            <v-row class="mb-0 pb-0 w-98">
              <v-col cols="3" class="mb-0 pb-0" v-if="sede">
                <span class="flexitem border-box">
                  <span class="r-box r-title2">
                    Lugar / Sede <br />
                    {{ sede.nombre }}
                  </span>
                </span>
              </v-col>
              <v-col cols="6" class="text-center mb-0 pb-0">
                <span class="flexitem recibo-number border-box"> RECIBO N° 000{{ recibo.numero_recibo }}</span>
              </v-col>
              <v-col cols="3" class="text-right mb-0 pb-0">
                <span class="flexitem border-box">
                  <span class="r-box r-title2">
                    Fecha Emision<br />
                    {{ formatDate(recibo.fecha_registro) }}
                  </span>
                </span>
              </v-col>
            </v-row>

            <div class="flexcontainer pa-1">
              <span class="flexitem">
                <span class="r-box r-title2">Forma Pago</span> <span class="r-box r-text"> {{ recibo.forma_pago }} </span>
              </span>
              <span class="flexitem" v-if="recibo.forma_pago_id == 2">
                <span class="r-box r-title2">Fecha de Pago</span> <span class="r-box r-text"> {{ formatDate(recibo.fecha_pago) }} </span>
              </span>
              <span class="flexitem"> </span>
              <span class="flexitem" v-if="recibo.numero_factura!='0'">
                <span class="r-box r-title2">N° Factura</span> <span class="r-box r-text"> {{ recibo.numero_factura }} </span>
              </span>
              <span class="flexitem" v-if="sede && sede.cuenta_bancaria">
                <span class="r-box r-title2">Banco/Cuenta </span>
                <span class="r-box r-text"> {{ sede.cuenta_bancaria.nombre }} - {{ sede.cuenta_bancaria.nro }}</span>
              </span>
              <span class="flexitem" v-if="programa">
                <span class="r-box r-title2">Programa</span> <span class="r-box r-text"> {{ programa.nombre_compuesto }} </span>
              </span>
              <span class="flexitem" v-if="estudiante">
                <span class="r-box r-title2">Estudiante</span>
                <span class="r-box r-text">
                  {{ estudiante.pri_apellido }}
                  {{ estudiante.seg_apellido }}
                  {{ estudiante.nombres }} -
                  {{ estudiante.num_doc }}
                </span>
              </span>
              <span class="flexitem">
                <span class="r-box r-title2">Señor(a) Depositante</span>
                <span class="r-box r-text">
                  {{ recibo.nombre_depositante }} {{ recibo.numero_documento_depositante ? ' - ' + recibo.numero_documento_depositante : '' }}
                </span>
              </span>
            </div>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  type="number"
                  v-model="monto_cancelar"
                  outlined
                  dense
                  label="Monto a cancelar"
                  background-color="#ffe17694"
                  :rules="[rules.loanMin]"
                  @keyup="autoLoadItems"
                  @change="autoLoadItems"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6" class="py-0">
                <v-data-table class="py-2" :headers="headers" :items="PlanPagos" hide-default-footer disable-pagination>
                  <template v-slot:top>
                    <p class="h4 text-center text-primary">{{ `Plan de Pagos`.toUpperCase() }}</p>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12" md="6" lg="6" class="py-0">
                <v-data-table class="py-2" :headers="headers" :items="items" hide-default-footer disable-pagination>
                  <template v-slot:top>
                    <p class="h4 text-center text-primary">{{ `Items`.toUpperCase() }}</p>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="dark"> <v-icon class="mr-1"> mdi-eye</v-icon> Previsualizar </v-btn>
            <v-btn color="blue darken-1" outlined rounded small @click="cancel"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import gql from 'graphql-tag';
import xaxios from '@/xaxios';

export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || 'Se requiere un valor',
        loanMin: (value) => value >= 1 || 'Valor debe ser mayor a 0',
        loanMinTwo: (monto, bs) => monto == bs || 'Monto no puede ser Diferente de ' + bs,
        loanMax: (monto, saldo) => monto <= saldo || 'Monto no puede ser mayor de ' + saldo,
      },
      api_rest: process.env.VUE_APP_API_REST,
      dialog: false,
      detalle: null,
      recibo: null,

      valid: false,
      monto_cancelar: 0,
      old_total: 0,
      new_total: 0,
      items: [],
      PlanPagos: [],
      estudiante: null,
      programa: null,
      asesor: null,
      sede: null,

      formas_pago: [
        //FIXME: this array is static
        { id: 1, nombre: 'Efectivo', descripcion: 'Efectivo' },
        { id: 2, nombre: 'Transferencia  - Depósito', descripcion: 'Transferencia' },
      ],
      headers: [
        { text: 'Concepto', value: 'concepto' },
        { text: 'N°', value: 'numero_cuota' },
        { text: 'Monto', value: 'monto' },
        { text: 'Saldo', value: 'saldo' },
      ],
      headersItems: [
        { text: 'Concepto de pago', value: 'concepto' },
        { text: 'N° Cuota', value: 'numero_cuota' },
        { text: 'Monto', value: 'monto' },
        { text: 'saldo', value: 'saldo' },
        { text: 'pago', value: 'pago' },
      ],
    };
  },
  methods: {
    showThisView(recibo, PlanPagos) {
      recibo.forma_pago = this.formas_pago.find((pago) => pago.id === recibo.forma_pago_id).nombre;
      this.getInscripcion(recibo.inscripcion_id);
      this.getUsuario(recibo.emisor_id, recibo.sede_id);
      this.getSede(recibo.sede_id, recibo);

      this.recibo = recibo;

      this.PlanPagos = PlanPagos;
      this.old_total = this.recibo.monto_editable;
      this.monto_cancelar = this.recibo.monto_editable;
      this.dialog = true;
      this.autoLoadItems();
    },
    updateTotal() {
      this.new_total = 0;
      this.items.forEach((item) => (this.new_total += +item.monto_calculado));
    },
    autoLoadItems() {
      for (let i = this.items.length; i > 0; i--) {
        const element = this.items[0];
        let index = this.items.indexOf(element);
        this.items.splice(index, 1);
        element.monto = element.pago2;
        this.PlanPagos.push(element);
      }
      this.PlanPagos.sort((a, b) => a.id - b.id);

      let auxArray = this.PlanPagos.filter((item) => item.saldo > 0 && !item.optional);
      let montoAux = this.monto_cancelar;

      for (let i = auxArray.length; i > 0; i--) {
        let firstElement = auxArray.shift();

        if (montoAux > 0 && firstElement.saldo > 0) {
          let index = this.PlanPagos.indexOf(firstElement);
          this.PlanPagos.splice(index, 1);
          let valor = montoAux >= firstElement.saldo ? firstElement.saldo : montoAux;
          firstElement.monto = valor;
          this.items.push(firstElement);
          montoAux = montoAux - valor;
        }
      }
      this.items.sort((a, b) => a.id - b.id);
    },
    concretarReciboEditable() {
      if (this.$refs.formDivider.validate()) {
        const url = `${this.api_rest}/api/pagos/recibo/modificar`;
        let data = {
          recibo_id: this.recibo.id,
          unidad_negocio_id: this.recibo.sede_id,
          cuotas: this.items.map((item) => ({
            cuota_id: item.id ? item.id : null,
            concepto: `${item.concepto} - ${item.numero_cuota}`,
            monto: item.monto,
            concepto_id: item.concepto_id,
            opcional: item.id ? false : true,
          })),
        };
        window.console.log(JSON.stringify(data), url);
        xaxios
          .put(url, data)
          .then(() => this.$root.$notify.show(`Recibos Cambiados correctamente`, { color: 'success' }))
          .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'danger' }));
        this.closeDialog();
        this.$emit('closeDialog');
      }
    },

    cancel() {
      for (let i = this.items.length; i > 0; i--) {
        const element = this.items[0];
        let index = this.items.indexOf(element);
        this.items.splice(index, 1);
        element.monto = element.pago2;
        this.PlanPagos.push(element);
      }
      this.PlanPagos.sort((a, b) => a.id - b.id);
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.valid = false;
      this.detalle = null;
      this.recibo = null;
      this.old_total = 0;
      this.new_total = 0;
      this.PlanPagos = [];
      this.items = [];
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.slice(0, 10).split('-');
      return `${day}/${month}/${year}`;
    },
    getInscripcion(id) {
      const sql = gql`query{getInscripcion(id: ${id}) { id estudiante{id, nombres, pri_apellido, seg_apellido, num_doc} programa{id nombre_compuesto} ${''}}}`;
      this.$apollo.query({ query: sql }).then(
        ({
          data: {
            getInscripcion: { estudiante, programa },
          },
        }) => {
          this.estudiante = estudiante;
          this.programa = programa;
        }
      );
    },
    getUsuario(id, sede_id) {
      const sql = gql`query{getUsuario(id: ${id}) { id firma cargos{ idusuario,idsede,idcargo, cargo {id, nombre}} datos_personales{ num_doc nombres pri_apellido seg_apellido} ${''}}}`;
      this.$apollo.query({ query: sql }).then(({ data }) => {
        this.asesor = data.getUsuario;
        this.asesor.cargo = this.asesor.cargos.find((cargo) => cargo.idsede == sede_id).cargo;
      });
    },
    getSede(id, recibo) {
      // window.console.log(recibo);
      const sql = gql`query{getSede(id: ${id}) { id nombre modelo_recibo cuentasBancarias {id nombre nro descripcion estado} ${''}}}`;
      this.$apollo.query({ query: sql }).then(({ data }) => {
        this.sede = data.getSede;
        this.sede.cuenta_bancaria = recibo && recibo.cuenta_bancaria_id ? this.sede.cuentasBancarias.find(({ id }) => id == recibo.cuenta_bancaria_id) : null;
        this.sede.modelo_recibo = process.env.VUE_APP_URL_BG_RECIBO_SEDE + this.sede.modelo_recibo;
      });
    },
  },
};
</script>
<style scoped>
.w-10 {
  max-width: 10%;
}
.w-20 {
  max-width: 20%;
}
.flexcontainer {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: row;
  padding-right: 5%;
}
.border-box {
  border: solid 1px #4d84c7c7;
  border-radius: 0.4em;
  box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.3);
}
.flexitem {
  margin-right: 0.3em;
  margin-left: 0.3em;
  margin-bottom: 0.1em;
  display: inline-flex;
  vertical-align: middle;
  justify-content: space-around;
}

.r-box {
  font-size: 0.8em;
  /* float: left; */
  line-height: 1.5;
  padding: 0.2em 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.r-title2 {
  font-weight: bold;
  color: #305077;
  background-color: rgba(237, 252, 255, 0.705);
  /* border-radius: 0.3em 0 0 0.3em; */
  /* border-right: 1px solid; */
}
.r-title3 {
  font-weight: bold;
  color: #305077;
  font-size: 0.8em;
  line-height: 1.5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.r-text {
  background-color: rgb(253, 253, 253);
  border-radius: 0 0.3em 0.3em 0;
}
.recibo-number {
  font-weight: bold;
  color: #305077;
  padding: 0.2em 1rem;
  font-size: 1.2rem;
}
</style>